import { render } from "./TheTrinhDoChuyenMonY.vue?vue&type=template&id=73b0248d"
import script from "./TheTrinhDoChuyenMonY.vue?vue&type=script&lang=js"
export * from "./TheTrinhDoChuyenMonY.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__